import axios from "axios";

const javaBaseUrl = () => {
  if (process.env.REACT_APP_NODE_ENV === "development") {
    return process.env.REACT_APP_API_DEV_JAVA_URL;
  } else if (process.env.REACT_APP_NODE_ENV === "production") {
    return process.env.REACT_APP_API_PROD_JAVA_URL;
  }
};

const nodeBaseUrl = () => {
  if (process.env.REACT_APP_NODE_ENV === "development")
    return process.env.REACT_APP_API_DEV_NODE_URL;
  if (process.env.REACT_APP_NODE_ENV === "production")
    return process.env.REACT_APP_API_PROD_NODE_URL;
};

// const javaAPI = axios.create({
//   baseURL: javaBaseUrl(),
//   headers: {
//     "Content-Type": "application/json",
//     // "Access-Control-Allow-Origin": "*",
//   },
//   withCredentials: true,
// });

// const nodeAPI = axios.create({
//   baseURL: nodeBaseUrl(),
//   headers: {
//     "Content-Type": "application/json",
//     "Access-Control-Allow-Origin": "*",
//   },
// });

// const toolsUrl = "https://tools-server-bcca978b87e0.herokuapp.com"; //dev
// const toolsUrl = "https://tools-server-prod-aee119fa4321.herokuapp.com"; //prod
// const toolsUrlV3 = "http://192.168.1.20:8001";
const toolsUrl = "https://tools-server-beta-272981233bb8.herokuapp.com"; //test

const toolsUrlV3 = "https://tools-v3-92f5213bcd80.herokuapp.com"; //v3

const toolsAPI = axios.create({
  baseURL: toolsUrl,
  headers: {
    "Content-Type": "Application/json",
  },
});

const toolsAPIV3 = axios.create({
  baseURL: toolsUrlV3,
  headers: {
    "Content-Type": "Application/json",
  },
});

// NODE APIs
// export const getLiquidityToken = (data) =>
//   nodeAPI.get(
//     `/api/token/allToken?size=${data.size}&page=${data.page}&filter=${data.filter}`
//   );

export const GetAllToken = (data) =>
  toolsAPI.get(
    `/api/token/pool/token?size=${data.size}&page=${data.page}&filter=${data.filter}`
  );

// JAVA APIs
// export const CreatePair = (data) => javaAPI.post("/Uniswap/newPair", data);
// export const RemoveLiquidity = (data) =>
//   javaAPI.post("/Uniswap/removeLiquidity", data);
// export const SwapToken = (data) => javaAPI.post("/Uniswap/TokenBuySell", data);
// export const ShowAllLiquidityPools = (walletAddress) =>
//   javaAPI.get(`/Uniswap/getPooledDataByWalletAddress/${walletAddress}`);

export const addLiquidity = (data) => toolsAPI.post("/api/liquidity/add", data);

export const removeLiquidity = (data, poolAddress) =>
  toolsAPI.delete(`/api/liquidity/remove/${poolAddress}`, { data });

export const TokenSwap = (data) => toolsAPI.post("/api/transaction/swap", data);

export const getAllLiquidityPools = (walletAddress) =>
  toolsAPI.get(`/api/token/pool/user/${walletAddress}`);

export const getLiquidityToken = (data) =>
  toolsAPI.get(
    `/api/token/all?size=${data.size}&page=${data.page}&filter=${data.filter}`
  );

// -----------------------v3----------------------
export const addLiquidityV3 = (data) =>
  toolsAPIV3.post("/api/v3/liquidity/add", data);

export const TokenSwapV3 = (data) =>
  toolsAPIV3.post("/api/v3/transaction/swap", data);

export const getViewPositionV3 = (walletAddress) =>
  toolsAPIV3.get(`/api/v3/token/pool/user/${walletAddress}`);

export const GetAllTokenV3 = (data) =>
  toolsAPIV3.get(
    `/api/v3/token/pool/token?size=${data.size}&page=${data.page}&filter=${data.filter}`
  );

export const getLiquidityTokenV3 = (data) =>
  toolsAPIV3.get(
    `/api/v3/token/all?size=${data.size}&page=${data.page}&filter=${data.filter}`
  );

export const removeLiquidityV3 = (data, poolAddress) =>
  toolsAPIV3.delete(`/api/v3/liquidity/remove/${poolAddress}`, { data });
